// react
// dependencies
import Fuse from "fuse.js";
import { Map, fromJS } from "immutable";

// constants
const FUSE_OPTIONS = {
	shouldSort: true,
	includeScore: false,
	threshold: 0.6,
	location: 0,
	distance: 100,
	maxPatternLength: 32,
	minMatchCharLength: 1,
	keys: ["name"],
};

const initialState = Map({
	queries: Map(),
	hashtags: new Fuse([], FUSE_OPTIONS),
});

export default function autocomplete(state = initialState, action) {
	switch (action.type) {
		case "AUTOCOMPLETE:SEARCH@SUCCESS":
			return state.setIn(["queries", action.url, action.query], fromJS(action.data.json));

		case "AUTOCOMPLETE:HASHTAGS@SUCCESS": {
			const newArray = [].concat(state.get("hashtags").list).map((hashtag) => hashtag.name);

			action.response.data.forEach((hashtag) => {
				if (newArray.indexOf(hashtag.name) < 0) {
					newArray.push(hashtag.name);
				}
			});

			const fuse = new Fuse(
				newArray.map((hashtag) => ({ name: hashtag })),
				FUSE_OPTIONS
			);

			return state.setIn(["hashtags"], fuse);
		}

		default:
			// never forget your default return state!
			return state;
	}
}
